import client from '../httpClient';

const postSendMails = (params, isShowMessage = true) => {
  return client.post('/send-mails', params, { isShowMessage, isShowLoading: false });
};

export default postSendMails;
